import React, { useState, useEffect } from "react";
import { TableCell, TableRow, IconButton, Checkbox } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import uuid from "react-uuid";
const SelectRow = (props) => {
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.ReceiptReducer.orders);
  const recall = orders.some((item) => props.orderId === item.orderId);

  const {
    orderId,
    startDate,
    boxNumber,
    patientName,
    doctorName,
    orderType,
    endDate,
    unitCount,
    unitPrice,
    totalPrice,
    discountPrice,
  } = props;

  const handleChange = () => {
    if (!recall) {
      dispatch({
        type: "add",
        payload: {
          orderId: orderId,
          startDate: startDate,
          boxNumber: boxNumber,
          patientName: patientName,
          doctorName: doctorName,
          orderTypeName: orderType,
          endDate: endDate,
          unitCount: unitCount,
          unitCost: unitPrice,
          totalCost: totalPrice,
          afterDiscount: totalPrice,
          details: [],
        },
      });
    }
  };

  return (
    <React.Fragment>
      <TableRow hover="true">
        <TableCell align="justify">
          <IconButton size="small" onClick={handleChange}>
            <AddIcon color="primary" />
          </IconButton>
        </TableCell>
        <TableCell align="justify">{props.boxNumber}</TableCell>
        <TableCell align="justify">{props.startDate}</TableCell>
        <TableCell align="justify">{props.patientName}</TableCell>
        <TableCell align="justify">{props.doctorName}</TableCell>
        <TableCell align="justify">{props.orderType}</TableCell>
        <TableCell align="justify">{props.unitCount}</TableCell>
        <TableCell align="justify">{props.endDate}</TableCell>
      </TableRow>
      <TableRow></TableRow>
    </React.Fragment>
  );
};
export default SelectRow;
